// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"121283ea","345":"65e4c037","691":"65e4c037"}[chunkId] + ".chunk.css";
};